import i18n from 'i18n/config';
import { languages } from 'i18n/utils';
import { PermissionId, workspacesConfig } from 'utils/powerLevelsConfig';

export enum DefaultRoleTypesEnum {
  MEMBER = 'Member',
  OWNER = 'Owner',
}

export const isDefaultRoleNameChanged = (roleName: string, defaultRoleType?: DefaultRoleTypesEnum) =>
  defaultRoleType ? defaultRoleType.toLowerCase() !== roleName.toLowerCase() : false;

export const getDefaultRoleTranslation = (
  defaultTypeRole: DefaultRoleTypesEnum | undefined,
  name?: string,
  language?: string
) => {
  if (!defaultTypeRole) return null;

  const translationKey = defaultTypeRole === DefaultRoleTypesEnum.MEMBER ? 'member' : 'owner';

  if (name && isDefaultRoleNameChanged(name, defaultTypeRole)) return null;
  if (language) return (i18n.getResource(language, 'translation', translationKey) || '') as string;

  return i18n.t(translationKey);
};

export const getReservedRoleNames = (defaultRoleTypes: DefaultRoleTypesEnum[]): string[] => {
  if (!defaultRoleTypes.length) return [];

  const reservedNames = new Set<string>();

  languages.forEach((lang) =>
    defaultRoleTypes.forEach((defaultRoleType) => {
      const translation = getDefaultRoleTranslation(defaultRoleType, undefined, lang);
      if (translation) reservedNames.add(translation);
    })
  );

  return Array.from(reservedNames);
};

export const getTargetRolePowerLevel = (permissions: Record<string, boolean>) =>
  Object.entries(permissions).reduce((max, [permissionId, enabled]) => {
    if (!enabled) return max;

    const configEntry = workspacesConfig[permissionId as PermissionId];
    return configEntry ? Math.max(max, configEntry.powerLevel) : max;
  }, 0);
